import { DELETE_USER_DATA, SET_USER_DATA } from "./UserTypes";

export function setUserData(data:object){
    return {type:SET_USER_DATA, payload:{...data}} 
}
export function deleteUserData(){
    return{type:DELETE_USER_DATA,}
}